import React, { useEffect, useRef, useState } from "react"
import { concatStrings } from "../utilities"
import DfbSymbol from "../ui-kit/dfb_symbol"

const DfbAlert = ({ message, type, style, autoClose, add_class }) => {
  const [visible, setVisible] = useState(false)
  const [mounted, setMounted] = useState(true)
  const isMountedRef = useRef(null)

  const baseClass = "dfb-Alert"
  const typeClass = type ? `${baseClass}--${type}` : ""
  const visibleClass = visible ? "is-visible" : ""
  const styleClass = style ? `${baseClass}--${style}` : ""

  const initAlert = () => {
    if (isMountedRef.current) {
      setMounted(true)
    }
    setTimeout(() => {
      if (isMountedRef.current) {
        setVisible(true)
      }
    }, 500)
  }

  const closeAlert = () => {
    if (isMountedRef.current) {
      setVisible(false)
    }
    setTimeout(() => {
      if (isMountedRef.current) {
        setMounted(false)
      }
    }, 500)
  }

  const initAutoClose = () => {
    if (autoClose !== false && isMountedRef.current) {
      setTimeout(() => {
        closeAlert()
      }, 5000)
    }
  }

  useEffect(() => {
    isMountedRef.current = true
    initAlert()
    initAutoClose()
    return () => (isMountedRef.current = false)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <div
      className={concatStrings(
        baseClass,
        typeClass,
        styleClass,
        visibleClass,
        add_class
      )}
      aria-live="polite"
      tabIndex="-1"
      role="alert"
    >
      <div className="dfb-Alert-message">{message}</div>
      <button
        type="button"
        className="dfb-Alert-closeButton"
        data-dismiss="alert"
        onClick={closeAlert}
      >
        <DfbSymbol icon_type="close" />
      </button>
    </div>
  )
}

export default DfbAlert
